export const NO_UNCHANGED = 'No - unchanged';
export const NO_EDITED = 'No - Edited';
export const YES_EDITED = 'Yes - Edited';
export const YES_UNCHANGED = 'Yes - unchanged';